/* eslint-disable import/no-anonymous-default-export */
import React from "react";
import {
  Container,
  Spinner,
  Dropdown,
  ButtonGroup,
  Tabs,
  Tab,
  Modal,
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBell,
  faBars,
  faSignOut,
  faSignIn,
  faCircleInfo,
} from "@fortawesome/free-solid-svg-icons";
import MainLayout from "../MainLayout";
import EmptyFeedCard from "../../../_uiComponents/EmptyFeedCard";
import useHiringPipeline from "./useHiringPipeline";
export default (props) => {
  const { allAssignedJobs, assignedJobsLoading, kanbanBoardHandler } =
    useHiringPipeline();

  return (
    <MainLayout activeMenuItem="kanban" pageName={"Assigned Jobs"}>
      <div className="container">
        {assignedJobsLoading ? (
          <div className="d-flex align-items-center justify-content-center">
            <Spinner animation="border" variant="primary" role="status">
              <span className="sr-only">Loading...</span>
            </Spinner>
          </div>
        ) : (
          <>
            {Array.isArray(allAssignedJobs?.results) &&
            allAssignedJobs?.results.length ? (
              <>
                <div className="row">
                  {Array.isArray(allAssignedJobs?.results) &&
                    allAssignedJobs?.results.map((item) => (
                      <div className="col-md-4 mb-3">
                        <div
                          className="border p-3 rounded shadow-sm cursor-pointer bg-white"
                          onClick={() => {
                            kanbanBoardHandler(item?.id);
                          }}
                        >
                          <h3 className="text-capitalize">{item.title}</h3>
                          <p>
                            Total Candidate:{" "}
                            <strong>{item?.total_candidates}</strong>
                          </p>

                          <ul className="d-flex flex-wrap fs-smallest">
                            <li className="mr-2 my-1">
                              <span
                                className={`pipeline-label d-inline-block rounded-sm label-blue px-2 py-1`}
                              >
                                Applied:{" "}
                                <strong>
                                  {item?.candidates_at_different_stages &&
                                    item.candidates_at_different_stages
                                      .applied}{" "}
                                </strong>
                              </span>
                            </li>
                            <li className="mr-2 my-1">
                              <span
                                className={`pipeline-label d-inline-block  px-2 py-1 rounded-sm label-light-green`}
                              >
                                Assessment:{" "}
                                <strong>
                                  {item?.candidates_at_different_stages &&
                                    item.candidates_at_different_stages
                                      .assessment}{" "}
                                </strong>
                              </span>
                            </li>
                            <li className="mr-2 my-1">
                              <span
                                className={`pipeline-label d-inline-block  px-2 py-1 rounded-sm label-voilet`}
                              >
                                Interview:{" "}
                                <strong>
                                  {item?.candidates_at_different_stages &&
                                    item.candidates_at_different_stages
                                      .interview}{" "}
                                </strong>
                              </span>
                            </li>
                            <li className="mr-2 my-1">
                              <span
                                className={`pipeline-label d-inline-block  px-2 py-1 rounded-sm label-yellow`}
                              >
                                Offer:{" "}
                                <strong>
                                  {item?.candidates_at_different_stages &&
                                    item.candidates_at_different_stages
                                      .offer}{" "}
                                </strong>
                              </span>
                            </li>
                            <li className="mr-2 my-1">
                              <span
                                className={`pipeline-label d-inline-block  px-2 py-1 rounded-sm label-green `}
                              >
                                Hired:{" "}
                                <strong>
                                  {item?.candidates_at_different_stages &&
                                    item.candidates_at_different_stages
                                      .hired}{" "}
                                </strong>
                              </span>
                            </li>
                            <li className="mr-2 my-1">
                              <span
                                className={`pipeline-label d-inline-block  px-2 py-1 rounded-sm label-red`}
                              >
                                Rejected:{" "}
                                <strong>
                                  {item?.candidates_at_different_stages &&
                                    item.candidates_at_different_stages
                                      .rejected}{" "}
                                </strong>
                              </span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    ))}
                </div>
              </>
            ) : (
              <EmptyFeedCard
                src="/assets/images/hiring-pipeline-empty-state-icon.svg"
                message={"No Candidates in the Hiring Pipeline"}
                description={
                  "The hiring pipeline is currently empty. Keep an eye on this space for candidates as they progress through the recruitment process."
                }
                btnText={"Discover New Candidates"}
                link={"/all-candidates"}
              />
            )}
          </>
        )}
      </div>
    </MainLayout>
  );
};
